import {
  FirestoreDataConverter,
  type DocumentData,
  type PartialWithFieldValue,
  QueryDocumentSnapshot,
  type SetOptions,
  SnapshotOptions,
  Timestamp,
  type WithFieldValue,
} from 'firebase/firestore'

/** Firestoreに保存される共通フィールド（Timestampのまま） */
export type FirestoreBaseDoc = {
  created_at: Timestamp
  updated_at: Timestamp
  is_deleted: boolean
}

/** アプリで使う共通フィールド（object / Date に変換） */
export type AppBase = {
  id: string
  /** Firestore ドキュメントパス（例: `school_accounts/abc123`）。履歴の updated_by_user_document_path 等で利用 */
  path: string
  created_at: Date
  updated_at: Date
  is_deleted: boolean
}

/** `FirestoreBaseDoc` + docId + path → `AppBase`（アプリ用）へ変換 */
export function baseFromDoc(id: string, doc: FirestoreBaseDoc, path: string): AppBase {
  return {
    id,
    path,
    created_at: doc.created_at?.toDate?.() ?? new Date(0),
    updated_at: doc.updated_at?.toDate?.() ?? new Date(0),
    is_deleted: doc.is_deleted,
  }
}

/**
 * Firestore converter（読み取り時に TDoc を返す）
 * - 「保存される形」をそのまま扱い、必要な変換は各モデルの `toX()` で行う
 */
export function makeDocConverter<TDoc extends DocumentData>(): FirestoreDataConverter<
  TDoc,
  TDoc
> {
  function toFirestore(modelObject: WithFieldValue<TDoc>): WithFieldValue<TDoc>
  function toFirestore(
    modelObject: PartialWithFieldValue<TDoc>,
    options: SetOptions,
  ): PartialWithFieldValue<TDoc>
  function toFirestore(
    modelObject: WithFieldValue<TDoc> | PartialWithFieldValue<TDoc>,
  ) {
    return modelObject
  }

  return {
    toFirestore,
    fromFirestore: (snap: QueryDocumentSnapshot, options: SnapshotOptions) =>
      snap.data(options) as TDoc,
  }
}

